module.exports = __webpack_public_path__ + "img/confused-bot.7c7a3e47.svg";